/**
 * A static image import is a URL string in Vite (Storybook) but a
 * `StaticImageData` object (`{ src, width, height }`) in Next.js. Normalise
 * to the URL so the same component works in both.
 */
export const assetUrl = (img: string | { src: string }) =>
  typeof img === 'string' ? img : img.src;
